"use strict";
exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/util/isArrayLike.js